import { fromEvent, from, of, EMPTY } from 'rxjs';
import * as Rx from 'rxjs'
import { filter, map, mergeMap, scan, merge, withLatestFrom, groupBy, skip, pairwise, distinct,
  startWith, tap, delay, combineLatest, switchMap, distinctUntilChanged, take, share } from 'rxjs/operators';
import _ from 'lodash'
// import { gql } from 'apollo-boost';
import { Dispatch } from 'architecture'

import { gql } from 'apollo-boost';
import client from '../apollo';

import { stateRefreshStream } from './functions'
// Current tags
// Add tag
// delete tag
// suggest tag
// current selected suggested tag

const ADD_TAG = gql`
  mutation addTag($state: String!, $tag: String!) {
    addTag(state: $state, tag: $tag) {
      success
    }
  }
`;

const REMOVE_TAG = gql`
  mutation removeTag($state: String!, $tag: String!) {
    removeTag(state: $state, tag: $tag) {
      success
    }
  }
`;



Dispatch.getState('Instances')
  .pipe(
    map(instances => Object.keys(instances).map(instance => ({...instances[instance], id: instance, text: '', tags: instances[instance].manualTags})))
  )
  .subscribe(e => Dispatch.mergeState('TagInput2', e))

  Dispatch.getState('States')
  .pipe(
    map(instances => Object.keys(instances).reduce((acc, instance) => ({
      ...acc, [instances[instance].id]: {
        id: instances[instance].id, 
        text: '', 
        //tags: instance.object.tags.reduce((acc, tag) => ({...acc, [tag.id]: { ...tag } }), {}),
        creator: instances[instance].creator,
        created: instances[instance].createdAt,
        type: instances[instance].instance.__typename,
        genericType: 'instance',
        data: instances[instance].instance
      }
    }), {})),
  )
  .subscribe(e => Dispatch.mergeState('TagInput', e))

const submit$ = Dispatch.getAction('TagInput', 'onKeyPress')
  .pipe(
    filter(e => e.value === 'Enter'),
    withLatestFrom(Dispatch.getState('TagInput')),
    map(([action, state]) => ({...state[action.id] })),
    share()
  )

const submitTag$ = submit$
  .pipe(
    filter(state => state.text.charAt(0) === '@'),
    withLatestFrom(Dispatch.getState('Tags')),
    map(([state, tags]) => ({ ...state, newTag: _.find(tags, instance => instance.name === state.text.toLowerCase()) && _.find(tags, instance => instance.name === state.text.toLowerCase()).id })),
    filter(e => !_.isNil(e.newTag)),
    share()
  )


  // Dispatch.getState('States')
  //   .pipe(
  //     switchMap(e => Dispatch.getState('TagInput.*.created')
  //     )
  //   )
  // .subscribe(e => console.log(e))
//For each id do this???

Dispatch.getAction('TagInput')
  .pipe(
    filter(e => !_.isNil(e.id)),
    distinct(e => e.id),
    mergeMap(state => {
      
      const addTag$ = Dispatch.getAction('TagInput', 'onKeyPress')
        .pipe(
          filter(action => action.id === state.id),
          filter(action => action.value === 'Enter'),
          withLatestFrom(Dispatch.getState('TagInput.' + state.id)),
          map(e => e[1]),
          filter(state => state.text.charAt(0) === '@'),
          withLatestFrom(Dispatch.getState('Tags')),
          // Check if tag exists
          map(([input, tags]) => _.find(tags, instance => instance.name === input.text.toLowerCase()) && _.find(tags, instance => instance.name === input.text.toLowerCase()).id ),
          //map(([input, tags]) => ({...states[e.id], tag: _.find(tags, instance => instance.name === state.text.toLowerCase()) })),
          filter(f => !_.isNil(f)),
          // tap(e => console.log("whatshere")),
          // tap(e => console.log(e)),
          // // Include new tag in tags
          // //map(f => [...Object.keys(f.tags), f.tag]),
          // map(state => ({...state.tags, [state.tag.id]: state.tag })),
          // FIXME fast adding second tag will cause switchmap to override previous
          //Save to server
          mergeMap(tag => from(client.mutate({
            mutation: ADD_TAG,
            variables: { state: state.id, tag: tag }
          }))
            .pipe (
              map(success => (acc) => {
                 var newState = {...acc};
                // // FIXME if multiple tags are pending
                // delete newState.add[state.id][tag];
                // return newState;
                //return {...acc, add: {...acc.add, [acc.add[state.id]]: acc.add[state.id].slice(_.findIndex(tag), 1)}}
                //return acc.add[state.id].splice(_.findIndex(tag), 1)
                acc.add[state.id].splice(_.findIndex(tag), 1)
                return newState
              }),
              tap(e => Dispatch.nextAction('Instance', 'refresh')),
              //Wait until states have updated also
              combineLatest(stateRefreshStream()
                .pipe(
                  filter(e => e === false)
                )),
              map(f => f[0]),
              // FIXME if multiple tags are pending
              startWith((acc) => {
                const currentTags = acc.add && acc.add[state.id] ? acc.add[state.id] : []
                return { ...acc, add: { ...acc.add, [state.id]: [ ...currentTags, tag ] }}
              })
            )
        )
      )

      const removeTag$ = Dispatch.getAction('TagInput', 'removeTag')
        .pipe(
          filter(action => action.id === state.id),
          //FIXME 2 removes fast will cause an error, needs to be grouped by id above
          map(e => e.tag),
          mergeMap((tag) => from(client.mutate({
            mutation: REMOVE_TAG,
            variables: { state: state.id, tag: tag }
          }))
            .pipe (
              map(success => (acc) => {
                // //acc.filter(item => item.id !== e.id)
                 var newState = {...acc};
                // // FIXME if multiple tags are pending
                // delete newState.remove[state.id];
                // return newState; 
                acc.remove[state.id].splice(_.findIndex(tag), 1)
                return newState
                //return {...acc, remove: {...acc.remove, [acc.remove[state.id]]: acc.remove[state.id].slice(_.findIndex(tag), 1)}}
              }),
              tap(e => Dispatch.nextAction('Instance', 'refresh')),
              //Wait until states have updated also
              combineLatest(stateRefreshStream()
                .pipe(
                  filter(e => e === false)
                )),
              map(f => f[0]),
              // FIXME if multiple tags are pending
              startWith((acc) => {
                const currentTags = acc.remove && acc.remove[state.id] ? acc.remove[state.id] : []
                return { ...acc, remove: { ...acc.remove, [state.id]: [ ...currentTags, tag ] }}
              })
            )
        )

          //map(([remove, inputs]) => ({ id: remove.id, tags: _.omit(inputs[remove.id].tags, remove.tag ) }))

          // switchMap(e => Dispatch.getState('TagInput.' + e.id + '.tags')
          //   .pipe(
          //     //tap(e => console.log("hi")),
          //     take(1),
          //     map(current => ({...current, [e.tag]: false})),
          //     map(tagss => ({ id: e.id, tags:tagss})),
          //     startWith({id: e.id, tags: {} })
          //   )
          //)
        )

      return Rx.merge(addTag$, removeTag$)
    }),
    scan((acc, next) => next(acc), {})
  )
  .subscribe(e => Dispatch.nextState('Tagger', e))


Dispatch.getAction('TagInput', 'onChange')
  .pipe(
  )
.subscribe(e => Dispatch.mergeState('TagInput.' + e.id, { text: e.value }))



Rx.merge(submitTag$, Dispatch.getAction('TagInput', 'onBlur'))
  .pipe(
   
  )
  
.subscribe(e => Dispatch.mergeState('TagInput.' + e.id, { text: '', key: Math.random(10000000) }))


Dispatch.getAction('TagInput', 'removeTag')
  .pipe(
    withLatestFrom(Dispatch.getState('TagInput')),
    map(([remove, inputs]) => ({ id: remove.id, tags: _.omit(inputs[remove.id].tags, remove.tag ) }))
  )
  .subscribe(e => Dispatch.mergeState('TagInput.' + e.id, { tags: e.tags }))


  // Dispatch.getAction('TagInput', 'addTag')
  //   .pipe(
  //     withLatestFrom(Dispatch.getState('TagInput'), Dispatch.getState('Tags')),
  //     map(([add, inputs, tags]) => ({id: add.id, tags: { ...inputs[add.id].tags, [add.tag]: tags[add.tag] }} ))

      
  //   )
  //   .subscribe(e => Dispatch.mergeState('TagInput', e))
    